<ng-container *ngIf="isShowDropDown">
    <eui-dropdown>
        <a class="eui-language-selector-link">
            <span class="eui-language-selector-link__icon eui-icon eui-icon-language-selector"></span>
            <span class="eui-language-selector-link__language-code">
                {{ (appShellService.state$ | async).activeLanguage }}
            </span>
        </a>
        <eui-dropdown-content>
            <div class="eui-language-selector-menu">
                <div *ngFor="let language of languages"
                        class="eui-language-selector-menu-language-item"
                        (click)="onLanguageChanged(language)">
                        {{ language.label }} ({{ language.code }})
                </div>
            </div>
        </eui-dropdown-content>
    </eui-dropdown>
</ng-container>

<ng-container *ngIf="isShowModal">
    <a class="eui-language-selector-link" (click)="open()">
        <span class="eui-language-selector-link__icon eui-icon eui-icon-language-selector"></span>
        <span class="eui-language-selector-link__language-code">
            {{ (appShellService.state$ | async).activeLanguage }}
        </span>
    </a>
</ng-container>
